export const parseLocale = (locale = '') => {
  const [language, country] = locale.split('_')
  return {
    language,
    country,
  }
}

export const getLanguageCode = (language = '', country = ''): string => {
  if (language === 'zh') {
    // WORKAROUND: Hong Kong & Taiwan use traditional Chinese.
    // Need to explicitly specify traditional/simplified Chinese in google maps.
    switch (country) {
      case 'HK':
      case 'TW':
        return 'zh-TW'
      default:
        return 'zh-CN'
    }
  }
  return language
}

export const getCurrentLocale = (pathname: string | null): string => {
  const segments = pathname?.split('/').filter(Boolean)
  if (segments && segments.length > 0) {
    const firstSegment = segments[0]
    // Check if first segment matches locale pattern (e.g., en_SG, zh_CN, etc.)
    const localePattern = /^[a-z]{2}_[A-Z]{2}$/
    if (localePattern.test(firstSegment as string)) {
      return firstSegment as string
    }
  }
  return '' // Return empty string if no locale found
}

export const languages = {
  en_JP: 'English',
  en_HK: 'English',
  en_ID: 'English',
  en_NZ: 'English',
  en_MO: 'English',
  en_MY: 'English',
  en_SG: 'English',
  en_SA: 'English',
  en_PE: 'English',
  en_GB: 'English',
  en_US: 'English',
  en_VN: 'English',
  en_TW: 'English',
  en_TH: 'English',
  zh_HK: '繁體中文',
  zh_TW: '繁體中文',
  zh_MO: '繁體中文',
  zh_MY: '中文',
  zh_SG: '中文',
  vi_VN: 'Tiếng Việt',
  th_TH: 'ไทย',
  ar_SA: 'Arabic',
  bm_MY: 'Bahasa',
  ja_JP: '日本語',
} as Record<string, string>
